import { css } from "styled-components";
import { Colors } from "./colors";

export type ColorTheme = 'navy' | 'gold' | 'white' | 'cream' | 'red' | 'pink' ;

export const getTheme = (theme: ColorTheme) => {
    switch(theme) {
        default:
        case 'navy':
            return css`
                background:${Colors.navy};
                color: ${Colors.lightGold};

                h2 {
                    color: ${Colors.white};
                }

                a {
                    color: ${Colors.trueWhite};
                }
            `
        case 'gold':
            return css`
                color:${Colors.navy};
                background: ${Colors.lightGold};

                h2 {
                    color: ${Colors.black };
                }

                a {
                    color: ${Colors.blue};
                }
            `
        case 'white':
            return css`
                color:${Colors.black};
                background: ${Colors.trueWhite};
            `
        case 'pink':
            return css`
                color:${Colors.black};
                background: ${Colors.pink};
            `
        case 'cream':
            return css`
                color:${Colors.black};
                background: ${Colors.white};
            `
        case 'red':
            return css`
                color: ${Colors.white};
                background: ${Colors.red};
            `
    }
} 
